import { memo } from 'react';
import NextImage from 'next/image';
import styled from 'styled-components';

import Text from 'components/common/text';
import listingPersons from 'data/listing-persons.json';
import { device } from 'styles/breakpoints';

function ListPriceAside() {
  return (
    <ListPriceAsideWrapper className="listing-aside">
      {listingPersons.map((person, idx) => (
        <div className="listing-aside-card" key={idx}>
          <div>
            <NextImage src={person.picture} width={44} height={44} />
          </div>

          <Text className="listing-aside-card-name" fw="bold">
            {person.name}
          </Text>
          <div>
            <NextImage src="/static/images/stars.png" width={72} height={14} />
          </div>
          <Text className="listing-aside-card-desc">{person.description}</Text>
        </div>
      ))}
    </ListPriceAsideWrapper>
  );
}

const ListPriceAsideWrapper = styled.div`
  padding: 60px 30px;
  background-color: ${({ theme }) => theme.colors.black}66;
  width: 100%;
  max-width: 330px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .listing-aside {
    &-card {
      &:not(:first-child) {
        margin-top: 36px;
      }
      > p {
        color: ${({ theme }) => theme.colors.white};
        text-align: center;
        font-size: 14px;
      }
      > div {
        display: flex;
        justify-content: center;
      }
      &-name {
        margin: 8px 0;
      }
      &-desc {
        margin-top: 16px;
      }
    }
  }
  @media ${device.smallLaptop} {
    max-width: 100%;
  }
`;

export default memo(ListPriceAside);
